<div class="debit-card-error-dialog" *transloco="let t">
	<div mat-dialog-title>
		<div class="op-right op-mb-8">
			<button
				mat-icon-button
				id="debitCardErrorDialogClose"
				[mat-dialog-close]="false"
				aria-label="{{ t('GLOBAL.close') }}"
			>
				<mat-icon svgIcon="op-close"></mat-icon>
			</button>
		</div>
		<p class="op-header-3" innerHTML="{{ t('DISBURSEMENT_SELECTION.DEBIT_CARD.NOT_SUPPORTED.title') }}"></p>
	</div>
	<div mat-dialog-content>
		<div class="op-gray op-mtb-20">
			{{ t('DISBURSEMENT_SELECTION.DEBIT_CARD.SWITCH.note') }}
		</div>
		<div class="op-body-2-font op-gray" *ngIf="data.disbursementType === disbursementType.check">
			<div>{{ t('DISBURSEMENT_SELECTION.DEBIT_CARD.SWITCH.youWillReceiveFunds') }}</div>
			<div class="debit-card-note op-mtb-8">
				<mat-icon svgIcon="op-attention-orange"></mat-icon>
				<span class="op-ml-5 op-black-bold">{{
					t('DISBURSEMENT_SELECTION.DEBIT_CARD.SWITCH.in5To7BusinessDays')
				}}</span>
			</div>
			<div>
				{{ data.address }}
			</div>
		</div>
	</div>
	<div mat-dialog-actions class="footer op-mt-20">
		<button mat-flat-button color="primary" (click)="onClick()" id="debitCardErrorDialogContinue">
			{{ 'GLOBAL.close' | transloco }}
		</button>
	</div>
</div>
